import React from "react";
import { Link } from "react-ui";

import { useMetrics } from "../../../Internals/Metrics/MetricsProviderContext";
import { ERROR_LOG_OPEN_FULL_RESULT } from "../../../metricsAction";
import { declint } from "../../../../Engine/utils";
import { ErrorLog } from "../../../../Engine/Core/ErrorManager/Utils/Models";
import { MenuAction } from "../MenuAction/MenuAction";
import { MinitourContainer } from "../../../Layout/Minitour/MinitourContainer";

import { ErrorLogModal } from "./ErrorLogModal";

export enum OpenExtendedErrorLogFromPlace {
    fromFullSuccessResult = "fromFullSuccessResult",
    fromSuccessCountItem = "fromSuccessCountItem",
    fromActionPanelDownButton = "fromActionPanelDownButton",
}

export interface ErrorLogModalLabelProps {
    errorLog: ErrorLog;
    type: "link" | "button";
    hasInternalErrors?: boolean;
    minitourEnabled: boolean;
    /** Пропс для метрик, чтобы понять из какого места открыли подробный протокол. Подробнее в FS-6753 */
    openedFrom: OpenExtendedErrorLogFromPlace;
}

export function ErrorLogModalLabel(props: ErrorLogModalLabelProps): JSX.Element {
    const track = useMetrics();
    const [opened, setOpened] = React.useState(false);

    const handleOpenModal = () => {
        track(ERROR_LOG_OPEN_FULL_RESULT, {
            errorCount: props.errorLog.errorsTotalCount,
            warningCount: props.errorLog.warningsTotalCount,
            openedFrom: props.openedFrom,
        });
        setOpened(true);
    };
    const handleCloseModal = () => setOpened(false);

    const successCountText = declint(props.errorLog.successesTotalCount, [
        "%s проверка прошла успешно",
        "%s проверки прошли успешно",
        "%s проверок прошли успешно",
    ]);

    return (
        <>
            <MinitourContainer
                minitourEnabled={props.minitourEnabled}
                openedFrom={"extendedProtocol"}
                id={"minitourExtendedProtocol"}
                label={"Вы можете посмотреть и распечатать результаты всех проверок, выполненных в отчете."}
                positions={["right top"]}
                width={"270px"}>
                {props.type == "button" ? (
                    <MenuAction
                        data-tid="ShowErrorLogModalButton"
                        icon="DocTextIcon"
                        text="Посмотреть все проверки"
                        onClick={handleOpenModal}
                    />
                ) : (
                    <Link data-tid="ShowErrorLogModalLink" onClick={handleOpenModal}>
                        {props.openedFrom === OpenExtendedErrorLogFromPlace.fromFullSuccessResult
                            ? successCountText
                            : "Показать подробный результат проверки"}
                    </Link>
                )}
            </MinitourContainer>
            {opened && (
                <ErrorLogModal
                    errorLog={props.errorLog}
                    onClose={handleCloseModal}
                    hasInternalErrors={props.hasInternalErrors}
                />
            )}
        </>
    );
}
